<!-- 批量修改溯源码 -->
<template>
    <div class="container">
        <div class="content">
            <Form :model="form_data" label-position="right" :label-width="150">
                <FormItem label="选择关联批次：">
                    <Select
                        class="w300"
                        v-model="form_data.batch_id"
                        clearable
                        filterable
                        placeholder="请选择"
                    >
                        <Option
                            v-for="item in batchList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.batch_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p>
                                选择批次，没有请先在【批次管理】中【新增批次】
                            </p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择关联产品：">
                    <Select
                        class="w300"
                        v-model="form_data.product_id"
                        clearable
                        filterable
                        placeholder="请选择"
                    >
                        <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.product_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p>选择关联的产品，将会修改关联该产品的溯源码</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择所属代理商：">
                    <Select
                        class="w300"
                        v-model="form_data.agent_id"
                        clearable
                        filterable
                        placeholder="请选择"
                    >
                        <Option
                            v-for="item in agentList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.agent_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p>选择默认所属的代理商，不选则暂时为空</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="选择ID号段：">
                    <Input
                        class="w100 mr24"
                        type="text"
                        v-model="form_data.start_id"
                        placeholder="请输入起始ID"
                    ></Input>
                    <Input
                        class="w100"
                        type="text"
                        v-model="form_data.end_id"
                        placeholder="请输入截止ID"
                    ></Input>
                </FormItem>
                <FormItem label="质保期：">
                    <Input
                        class="w300"
                        type="text"
                        v-model="form_data.warranty_days"
                        placeholder="请输入质保期"
                        ><span slot="append">天</span></Input
                    >
                </FormItem>
                <FormItem label="生产时间：">
                    <DatePicker
                        class="w300"
                        :value="form_data.productive_time"
                        type="date"
                        placeholder="点击选择时间"
                        @on-change="changeProductiveTime"
                    ></DatePicker>
                </FormItem>
                <FormItem label="过期时间：">
                    <DatePicker
                        class="w300"
                        :value="form_data.expiration_date"
                        type="date"
                        placeholder="点击选择时间"
                        @on-change="changeExpirationDate"
                    ></DatePicker>
                </FormItem>
                <FormItem label="重新关联批次：">
                    <Select
                        class="w300"
                        v-model="form_data.new_batch_id"
                        clearable
                        filterable
                        placeholder="模糊搜索批次名"
                        label-in-value
                        @on-change="changeNewBatch"
                    >
                        <Option
                            v-for="item in batchList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.batch_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">
                                如果关联的批次不变，请留空。
                                <span class="theme-color"
                                    >如果重新关联批次请跟产品对应修改，以免批次和产品关联对应混乱！</span
                                >
                            </p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="重新关联产品：">
                    <Select
                        class="w300"
                        v-model="form_data.new_product_id"
                        clearable
                        filterable
                        placeholder="模糊搜索产品名称"
                        label-in-value
                        @on-change="changeNewProduct"
                    >
                        <Option
                            v-for="item in productList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.product_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">
                                如果关联的产品不变，请留空。
                                <span class="theme-color"
                                    >如果重新关联产品请跟批次对应修改，以免批次和产品关联对应混乱！</span
                                >
                            </p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="重新关联代理商：">
                    <Select
                        class="w300"
                        v-model="form_data.new_agent_id"
                        clearable
                        filterable
                        placeholder="模糊搜索代理商名称"
                        label-in-value
                        @on-change="changeNewAgent"
                    >
                        <Option
                            v-for="item in agentList"
                            :value="item.id"
                            :key="item.id"
                            >{{ item.agent_name }}</Option
                        >
                    </Select>
                    <Tooltip max-width="250" placement="right" theme="light">
                        <Icon
                            class="cursor-p ml24"
                            type="md-help-circle"
                            size="20"
                            color="#FF4838"
                        />
                        <div slot="content">
                            <p class="ml12">如果关联的代理商不变，请留空。</p>
                        </div>
                    </Tooltip>
                </FormItem>
                <FormItem label="是否启用：">
                    <i-switch
                        v-model="form_data.status"
                        size="large"
                        true-color="#FF761D "
                        :true-value="1"
                        :false-value="2"
                        @on-change="changeStatus"
                    >
                        <span slot="open">开启</span>
                        <span slot="close">关闭</span>
                    </i-switch>
                </FormItem>
                <div class="footer">
                    <Button
                        class="theme-bc theme-default-color"
                        @click="submitForm"
                        >确定</Button
                    >
                </div>
            </Form>
        </div>
    </div>
</template>

<script>
import {
    qrcode_batch_edit,
    product_select,
    batch_select,
    agent_select,
} from "@/api/index";
export default {
    data() {
        return {
            form_data: {
                batch_id: "",
                product_id: "",
                agent_id: "",
                status: 2,
                productive_time: "",
                warranty_days: "",
                expiration_date: "",
                start_id: "",
                end_id: "",
                new_batch_id: "",
                new_product_id: "",
                new_agent_id: "",
            },
            batchList: [],
            productList: [],
            agentList: [],
            new_batch_data: "",
            new_product_data: "",
            new_agent_data: "",
            status_data: false,
        };
    },
    mounted() {
        this.getProductSelect();
        this.getBatchSelect();
        this.getagentSelect();
    },
    methods: {
        changeProductiveTime(e) {
            if (e) {
                this.form_data.productive_time = e;
            } else {
                this.form_data.productive_time = "";
            }
        },
        changeExpirationDate(e) {
            if (e) {
                this.form_data.expiration_date = e;
            } else {
                this.form_data.expiration_date = "";
            }
        },
        // 下拉
        getProductSelect() {
            product_select()
                .then((res) => {
                    this.productList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getBatchSelect() {
            batch_select()
                .then((res) => {
                    this.batchList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        getagentSelect() {
            agent_select()
                .then((res) => {
                    this.agentList = res.data;
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        changeNewBatch(e) {
            if (e) {
                this.new_batch_data = e.label;
            }
        },
        changeNewAgent(e) {
            if (e) {
                this.new_agent_data = e.label;
            }
        },
        changeNewProduct(e) {
            if (e) {
                this.new_product_data = e.label;
            }
        },
        changeStatus(e) {
           if(e){
                this.form_data.status = e;
                this.status_data = true;
           }
        },
        submitForm() {
            if (this.form_data.start_id * 1 > this.form_data.end_id * 1) {
                this.$Message.error("起始ID要小于截止ID");
                return;
            }
            var tip_data = "是否确认修改";
            if (this.form_data.new_batch_id) {
                tip_data =
                    tip_data + "，此次将会把批次修改为：" + this.new_batch_data;
            }
            if (this.form_data.new_product_id) {
                tip_data =
                    tip_data +
                    "，此次将会把产品修改为：" +
                    this.new_product_data;
            }
            if (this.form_data.new_agent_id) {
                tip_data =
                    tip_data + "，此次将会代理商修改为：" + this.new_agent_data;
            }
            this.$Modal.confirm({
                title: "提示",
                content: tip_data,
                onOk: () => {
                    if(this.status_data){
                        var data = {
                            batch_id: this.form_data.batch_id,
                            product_id: this.form_data.product_id,
                            agent_id: this.form_data.agent_id,
                            status: this.form_data.status,
                            productive_time: this.form_data.productive_time,
                            warranty_days: this.form_data.warranty_days,
                            expiration_date: this.form_data.expiration_date,
                            start_id: this.form_data.start_id,
                            end_id: this.form_data.end_id,
                            new_batch_id: this.form_data.new_batch_id,
                            new_product_id: this.form_data.new_product_id,
                            new_agent_id: this.form_data.new_agent_id,
                        }
                    }else {
                        var data = {
                            batch_id: this.form_data.batch_id,
                            product_id: this.form_data.product_id,
                            agent_id: this.form_data.agent_id,
                            productive_time: this.form_data.productive_time,
                            warranty_days: this.form_data.warranty_days,
                            expiration_date: this.form_data.expiration_date,
                            start_id: this.form_data.start_id,
                            end_id: this.form_data.end_id,
                            new_batch_id: this.form_data.new_batch_id,
                            new_product_id: this.form_data.new_product_id,
                            new_agent_id: this.form_data.new_agent_id,
                        }
                    }
                    qrcode_batch_edit(data)
                        .then((res) => {
                            this.form_data.batch_id = "";
                            this.form_data.product_id = "";
                            this.form_data.agent_id = "";
                            this.form_data.status = 2;
                            this.form_data.productive_time = "";
                            this.form_data.warranty_days = "";
                            this.form_data.expiration_date = "";
                            this.form_data.start_id = "";
                            this.form_data.end_id = "";
                            this.form_data.new_batch_id = "";
                            this.form_data.new_product_id = "";
                            this.form_data.new_agent_id = "";
                            this.status_data = false;
                            this.$Message.success(res.msg);
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.footer {
    margin: 24px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
.cursor-p {
    cursor: pointer;
}
</style>